import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { usePageStore } from '@/store';

import util from '../../common/util';
import { searchRealTimeListings } from '../../common/search-request';
import Count from './count.vue';
// import { indexMixin } from './center-adapt';
import { normal } from '../defaultSpacing';

import poolSend from "./poolSend";

import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';
import { buildUrl } from '@/router/index.js';
const isDoubleLevelList = list => {
    if (!list || !list.length) {
        return false;
    }
    return Boolean(list[0]?.list && list[0]?.id);
};

const getSelectedQuickSearch = (list, key, lng) => {
    for (let i = 0; i < list.length; i++) {
        let item = list[i];
        if (item.id != key) {
            continue;
        }
        //_sysLanguage in cms, sysLanguage in site
        const languageValue =
            item?.sysLanguage?.[lng] ?? item?._sysLanguage?.[lng];
        if (!languageValue) {
            return item;
        }
        let newItem = {};
        newItem.title = languageValue.title ?? item.title;
        if (languageValue.list) {
            newItem.list = item.list.map((v, idx) => ({
                ...v,
                title: languageValue.list[idx]?.title ?? v.title
            }));
        } else {
            newItem.list = item.list || [];
        }
        return newItem;
    }
    return {
        list: [],
        title: ''
    };
};
export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-quick-search'
    },
    mixins: [spaceMixin('colorBlock'), colorMixin()],
    // mixins: [indexMixin],
    data: function() {
        return {
            group: {
                list: [],
                key: 'Default'
            },
            title: '',
            list: [],
            collapse: true,
            titleSize: 24,
            requestPromiseAll: [], // Make multiple requests at once 
            countMap: {}, // current data , all requested data 
            fullColumn: false,
            ...normal
        };
    },
    components: { Count },
    computed: {
        ...rootMapState(usePageStore, {
            "isSearchCenter": store => store.isSearchCenter,
            "currentLanguage": store => store.currentLanguage,
            "page": store => store.page || {},
            "siteId": "siteId"
        }),
        selectedQuickSearch() {
            if (isDoubleLevelList(this.group.list)) {
                return getSelectedQuickSearch(
                    this.group.list,
                    this.group.key,
                    this.currentLanguage
                );
            }
            if (isDoubleLevelList(this.list)) {
                return getSelectedQuickSearch(
                    this.list,
                    this.group.key,
                    this.currentLanguage
                );
            }
            let list = (this.group?.list?.length && util.isArray(this.group?.list))
                ? this.group?.list
                : (this.list?.length && util.isArray(this.list))
                    ? this.list
                    : [];
                
            return {
                title: this.title || '',
                list
            };
        },
        
        
        filteredList() {
            return this.selectedQuickSearch.list
                .filter(search => search && search.show !== false)
                .map(search => {
                    let presetParams = this.getPresetParams(
                            this.isSearchCenter
                                ? search.presetFiltersV2
                                : search.presetFilters
                        ),
                        searchKey =
                            (search.listingSource || '') +
                            JSON.stringify(presetParams);
                    let searchId = search.quickSearchId;
                    let options = searchId ? 
                        { searchId } : 
                        {
                            listingSortOptions:
                                search.listingSortOptions &&
                                JSON.stringify(search.listingSortOptions),
                            listingSource: search.listingSource,
                            presetParams: JSON.stringify(presetParams),
                            uiConfig: JSON.stringify(search.uiConfig || {}),
                            quickSearchCount:
                                this.countMap[searchKey] || '0',
                            quickSearchKey: searchKey,
                            mode: search.mode || 'grid'
                        };
                    return {
                        ...search,
                        presetParams: presetParams,
                        key: searchKey,
                        href: buildUrl({ name: 'listing', query: options })
                    };
                });
        },
        requestArr() {
            return this.filteredList
                .filter(item => this.countMap[item.key] === undefined)
                .map(this.generateRequestOption);
        },
        showmore() {
            let len = this.filteredList.length
            return  this.isMobileSize ? len > 5 : len > 15;
        },
        btnText() {
            return this.collapse ? 'More' : 'Less';
        },
        mlsCount({ page }) {
            let mlsOrgs = page.mlsOrgs || [],
                count = Number.MAX_VALUE;
            for (let i = 0, len = mlsOrgs.length; i < len; i++) {
                let limit = mlsOrgs[i].listingPictureLimit;
                if (limit !== -1 && limit < count) {
                    count = limit;
                }
            }
            return count;
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        suitableImg() {
            return this.isMobileSize
                ? this.bgImgOpt.mobileSrc
                : this.bgImgOpt.src;
        },
    },
    created() {
        if (this.group) {
            this.group.list = this.group.list || [];
        } else {
            this.group = {
                list: [],
                key: 'Default'
            };
        }
    },
    beforeMount() {
        this.debouncedGetQuickSearchCount = util.debounce(
            this.getQuickSearchCount,
            0
        );
        this.getQuickSearchCount();
    },
    watch: {
        'list'(newVal) {
            if (newVal?.length > 0 && util.inCms) {
                this.debouncedGetQuickSearchCount();
            }
        }
    },
    methods: {
        getPresetParams(presetFilters) {
            if (!presetFilters) {
                return {};
            }
            let obj = {};
            if (this.isSearchCenter) {
                Object.keys(presetFilters).forEach(key => {
                    if (key.toLowerCase() === 'location') {
                        let { mapSearch, rect } = presetFilters[key];
                        if (mapSearch && rect) {
                            rect = rect.split(',');
                            presetFilters[key]['mapPath'] = JSON.stringify([
                                { lat: rect[0], lng: rect[1] },
                                { lat: rect[2], lng: rect[1] },
                                { lat: rect[2], lng: rect[3] },
                                { lat: rect[0], lng: rect[3] }
                            ]);
                            delete presetFilters[key].mapSearch;
                            delete presetFilters[key].rect;
                        }
                    }

                    obj[key] = presetFilters[key];
                });
            } else {
                presetFilters.forEach(filter => {
                    if (filter.dn === 'mapSearch') {
                        let rect = filter.rect.split(',');
                        obj['mapPath'] = JSON.stringify([
                            { lat: rect[0], lng: rect[1] },
                            { lat: rect[2], lng: rect[1] },
                            { lat: rect[2], lng: rect[3] },
                            { lat: rect[0], lng: rect[3] }
                        ]);
                    } else {
                        if (filter && Array.isArray(filter.values)) {
                            obj[filter.dn] = filter.values.join(
                                filter.split || ','
                            );
                        }
                    }
                });
            }
            return obj;
        },
        generateRequestOption(item) {
            let listingType = '',
                listingSource = (item.listingSource || '')
                    .toLowerCase()
                    .replace(/^\d\+/, '')
                    .replace(/\+/g, ' ');
            listingType = util.getListingTypeFromListingSource(listingSource)
            let presetParams = item.presetParams || {};
            let key = (presetParams.key && presetParams.key.split(';')) || [];
            delete presetParams.key;

            const params = Object.assign(
                {
                    featureListingName:
                        !item.listingSource ||
                        [
                            'all listings',
                            'sold listings',
                            'single property promotion'
                        ].indexOf(listingSource) !== -1
                            ? undefined
                            : item.listingSource
                                .replace(/^\d\+/, '')
                                .replace(/\+/g, ' '),
                    listingType: listingType,
                    siteId: this.siteId,
                    t: Date.now()
                },
                this.isSearchCenter
                    ? { condition: JSON.stringify(presetParams) }
                    : {
                        key: key
                            .map(
                                k =>
                                    (k && k.split(':').slice(1).join(':')) ||
                                      ''
                            )
                            .join(';'),
                        keywordType: key
                            .map(k => (k && k.split(':')[0]) || 'none')
                            .join(';'),
                        ...presetParams
                    }
            );
            return {
                params,
                key: item.key
            };
        },
        toggleShowMore() {
            this.collapse = !this.collapse;
        },
        getQuickSearchCount() {
            if (this.platform.isBot || !this.requestArr.length) {
                return;
            }
            poolSend.addTasks(
                this.requestArr.map(r => {
                    return () => this.requestCount(r.params, r.key)
                })
            );
        },
        requestCount(params, key) {
            params.timezone = this.getCookie('timezone') || util.getTimeZone();
            params.quickSearch = true;
            return searchRealTimeListings.call(this, {
                params,
                type: 'quickSearch',
                globalData: this.page
            })
                .then(data => {
                    this.countMap[key] = data.counts || 0;
                })
                .catch(e => console.log(e));
        }
    }
};
